import { createSlice } from '@reduxjs/toolkit';
import { makeActionCreator } from '../helpers';
import {
  SponsorEligibilityFetchAction,
  SponsorEligibilityFetchSuccessAction,
  SponsorEligibilityState,
} from './sponsorEligibility.types';

const initialState: SponsorEligibilityState = {
  loading: false,
  error: undefined,
  data: null,
};

const { actResolve, actReject, act } =
  makeActionCreator<SponsorEligibilityState>();

export const SponsorEligibilitySlice = createSlice({
  name: 'sponsorEligibility',
  initialState,
  reducers: {
    fetchSponsorEligibility: act<SponsorEligibilityFetchAction['payload']>(
      () => ({
        loading: true,
        error: undefined,
      })
    ),
    fetchSponsorEligibilitySuccess:
      actResolve<SponsorEligibilityFetchSuccessAction['payload']>('data'),
    fetchSponsorEligibilityError: actReject(),
    clear: state => {
      state.loading = false;
      state.error = undefined;
      state.data = null;
    },
  },
});
